import type { RouteObject } from 'react-router'
import { Outlet } from 'react-router-dom'

export const messagingRoutes: RouteObject = {
  path: 'messaging',
  async lazy() {
    const { Messaging } = await import(
      '../client/components/Messaging/index.js'
    )

    return {
      element: (
        <Messaging>
          <Outlet />
        </Messaging>
      ),
    }
  },
  children: [
    {
      path: 'new',
      async lazy() {
        const { MessagingLayout } = await import(
          '../client/components/Messaging/MessagingLayout.js'
        )

        return { element: <MessagingLayout chatOpen newChat /> }
      },
    },
    {
      path: 'settings',
      async lazy() {
        const { MessagingSettingsLayout } = await import(
          '../client/components/Messaging/MessagingSettingsLayout.js'
        )

        return {
          element: (
            <MessagingSettingsLayout>
              <Outlet />
            </MessagingSettingsLayout>
          ),
        }
      },
      children: [
        {
          path: 'blocked',
          async lazy() {
            const { BlockedMembersSettings } = await import(
              '../client/components/Messaging/Settings/BlockedMembersSettings.js'
            )

            return { Component: BlockedMembersSettings }
          },
        },
        {
          path: '*',
          async lazy() {
            const { MemberMessagingSettings } = await import(
              '../client/components/Messaging/Settings/MemberMessagingSettings.js'
            )

            return { Component: MemberMessagingSettings }
          },
        },
      ],
    },
    {
      path: ':slug',
      async lazy() {
        const { MessagingLayout } = await import(
          '../client/components/Messaging/MessagingLayout.js'
        )

        return { element: <MessagingLayout chatOpen /> }
      },
    },
    {
      path: '*',
      async lazy() {
        const { MessagingLayout } = await import(
          '../client/components/Messaging/MessagingLayout.js'
        )

        return { Component: MessagingLayout }
      },
    },
  ],
}
